module.exports = __webpack_public_path__ + "img/5-1_06.5a6d6f33.jpg";